import { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { useFloatingStatusContext } from '~/contexts/floating-status.context'

export const FloatingStatusPortal = ({ children }: { children: ReactNode }) => {
  const { divContainerRef } = useFloatingStatusContext()

  if (!divContainerRef?.current) return null
  return createPortal(children, divContainerRef.current)
}
